import {
  getBusinessClientContactFormFields,
  getContactData,
} from 'utils/clientFormOptions';
import { ROLES } from 'utils/constants';
import { BusinessClientInfo } from './constants/informationText';
import { getItemOrDefaultToValue } from './details';

//use this generic form field object to create business client  subpanel

export const getBusinessClientFormFields = (
  addContact,
  countries,
  languages,
) => [
  {
    field: 'businessClientId',
    label: 'Business Client ID',
    type: 'text',
    size: 'half',
    placeholder: 'Enter id',
    info: BusinessClientInfo.id,
  },
  {
    field: 'companyName',
    type: 'text',
    required: true,
    size: 'half',
    placeholder: 'Enter company name',
  },
  {
    label: 'Address',
    field: 'businessClientAddress',
    type: 'address',
    size: 'half',
    placeholder: 'Enter street address',
    info: BusinessClientInfo.address,
  },
  {
    field: 'newContact',
    type: 'toggle',
    size: 'half',
    info: BusinessClientInfo.contact,
    alignment: 'center',
  },
  getBusinessClientContactFormFields(addContact, countries, languages),
  {
    field: 'description',
    maxLength: 250,
    type: 'textArea',
    placeholder: 'Enter description',
  },
];
//create business client payload data out of form values
export const getBusinessClientData = (values, generalInfo) => {
  const ids = values?.departments &&
    values?.departments.length > 0 && {
      departmentIds: getItemOrDefaultToValue(
        values,
        'departments',
        undefined,
      )?.map(m => m.id),
    };
  return {
    ...(values.businessClientId && {
      businessClientId: values.businessClientId,
    }),
    name: values.companyName,
    address: values.businessClientAddress,
    description: values.description,
    securityCompanyId: generalInfo.securityCompanyId,
    securityCompanyName: generalInfo.securityCompanyName,
    ...(ids && { departmentIds: ids.departmentIds }),
  };
};
//create business client and site payload data out of form values
export const getSiteWithBusinessClient = ({
  values,
  securityCompanyName,
  securityCompanyId,
  region,
  generalInfo,
  addContact,
}) => {
  const ids = values?.departments &&
    values?.departments.length > 0 && {
      departmentIds: getItemOrDefaultToValue(
        values,
        'departments',
        undefined,
      )?.map(m => m.id),
    };
  const siteData = {
    ...values,
    securityCompanyName,
    securityCompanyId,
    regionId: region.id,
    regionName: region.name,
    ...(ids && { departmentIds: ids.departmentIds }),
  };
  let businessClientData = getBusinessClientData(values, generalInfo);
  if (addContact || values.newContact) {
    const contactData = getContactData(values, generalInfo, ROLES);
    businessClientData = { ...businessClientData, contact: contactData };
  }
  return { ...siteData, businessClientData };
};
